export const appList = (state) => state.appList;

export const loadingApps = (state) => state.loadingApps;
